/**
 * Login state helpers — replaces the Solid loginSignal from the original CMS codebase.
 *
 * In the Next.js app, login status lives in the Redux store (@repo/web-store).
 * Since the analytics module is a utility package that can't directly use React hooks,
 * we expose imperative getters that the app layer can set.
 */

import type { LoginStatus } from "@repo/web-store";

let currentLoginStatus: LoginStatus = "pending";
let currentIsTokenPresent = false;

/**
 * Called by the app layer (e.g. via a React effect) to keep analytics in sync
  with the Redux auth state.
 */
export const setAnalyticsLoginStatus = (status: LoginStatus): void => {
	currentLoginStatus = status;
};

export const setAnalyticsTokenPresent = (present: boolean): void => {
	currentIsTokenPresent = present;
};

export const getLoginStatus = (): LoginStatus => currentLoginStatus;
export const getIsTokenPresent = (): boolean => currentIsTokenPresent;
